import { Menu } from 'antd';
import React from 'react';

const EnhancedMenu = (props: any) => <Menu {...props} />;

EnhancedMenu.Item = Menu.Item;

export default EnhancedMenu;
